import { render, staticRenderFns } from "./MainRegistration.vue?vue&type=template&id=5ce95282&"
import script from "./MainRegistration.vue?vue&type=script&lang=js&"
export * from "./MainRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports